import routes from './routes';
import { PtBr, En, Es } from './locales';

const CertificationModule = {
    name: 'certification',
    routes,
    locales: {
        'pt-BR': PtBr,
        en: En,
        es: Es
    }
};

export default CertificationModule;
